import {
  BASE_API_URL,
  GET_BASICSTATS_END_POINT,
  GET_CONTENTTHEME_END_POINT,
  GET_DASHBOARD_PERFORMANCE,
  GET_HEATMAP_CHART_END_POINT,
  GET_PIE_CHART_END_POINT,
  GET_SUNBURST_END_POINT,
  PARAM_SYSTEMUID,
  PARAM_TIMEZONE,
  PARAM_USERNAME,
  SYSTEM_DATETIME_FORMAT,
} from "../utils/constants";
import moment from "moment";
import mainStore from "../MainStore/store";

const getUserName = () =>
  localStorage.getItem("username") || "akshaykarangale@gmail.com";
const getSystemUid = () =>
  localStorage.getItem("system_uid") || "569a826c-d7f5-4176-bfda-43eb21940937";
const getJobId = () =>
  localStorage.getItem("job_id") || "618cf2e8ace56b13b9c28cab";

const getHandleName = () => localStorage.getItem("handle_name") || "predis.ai";
const getPlatform = () => localStorage.getItem("platform") || "ig";
// const getTimeZone = () => localStorage.getItem("timezone") || "Asia/Calcutta";
const { username, systemUid, userTimezone, jobId } =
  mainStore.getState().globalReducer;
const generatePayload = (data) => {
  const payload = {
    username: username,
    system_uid: systemUid,
    // job_id: getJobId(),
    // handle_name: getHandleName(),
    // platform: getPlatform(),
    timezone: userTimezone,
    ...data,
  };
  return Object.keys(payload)
    .map((key) => `${key}=${payload[key]}`)
    .join("&");
};

const createService = (END_POINT, payload) => {
  return `${BASE_API_URL}/${END_POINT}/?${payload}`;
};

// Todo - below functions can also me merged into one with one argument
// deprecated
export const getHeatmapChartData = async () => {
  const extraPayload = {
    date_from: "1900-01-01 00:00:00",
    date_to: "2022-05-25 00:00:00",
  };
  const payload = generatePayload(extraPayload);
  const service = createService(GET_HEATMAP_CHART_END_POINT, payload);
  try {
    const response = await fetch(service, { method: "GET" });
    return response.json();
  } catch (error) {
    return [];
  }
};

export const getPieChartData = async () => {
  const extraPayload = {
    date_from: "1900-01-01 00:00:00",
    date_to: "2022-05-25 00:00:00",
  };
  const payload = generatePayload(extraPayload);
  const service = createService(GET_PIE_CHART_END_POINT, payload);
  try {
    const response = await fetch(service, { method: "GET" });

    return response.json();
  } catch (error) {
    return [];
  }
};
export const getSunburstData = async () => {
  const extraPayload = {
    date_from: "1900-01-01 00:00:00",
    date_to: "2022-05-25 00:00:00",
  };
  const payload = generatePayload(extraPayload);
  const service = createService(GET_SUNBURST_END_POINT, payload);
  try {
    const response = await fetch(service, { method: "GET" });

    return response.json();
  } catch (error) {
    return [];
  }
};
export const getChartData = async (
  endpoint,
  handleName,
  job_id,
  platform,
  startDate,
  endDate,
  type,
  cluster_id
) => {
  const extraPayload = {
    date_to: moment(endDate).format(SYSTEM_DATETIME_FORMAT),
    date_from: moment(startDate).format(SYSTEM_DATETIME_FORMAT),
    handle_name: handleName,
    job_id: job_id,
    platform: platform,
    ...(type && { type: type }),
    ...(cluster_id && { cluster_id: cluster_id }),
  };
  const payload = generatePayload(extraPayload);
  const service = createService(endpoint, payload);
  try {
    const response = await fetch(service, { method: "GET" });
    return response.json();
  } catch (error) {
    return [];
  }
};

export const getPostData = async (
  endpoint,
  handleName,
  page,
  job_id,
  platform,
  startDate,
  endDate,
  cluster_id
) => {
  // ;
  const extraPayload = {
    date_to: moment(endDate).format(SYSTEM_DATETIME_FORMAT),
    date_from: moment(startDate).format(SYSTEM_DATETIME_FORMAT),
    page_number: page,
    handle_name: handleName,
    job_id: job_id,
    platform: platform,
    ...(cluster_id && { cluster_id: cluster_id }),
  };
  const payload = generatePayload(extraPayload);
  const service = createService(endpoint, payload);
  try {
    const response = await fetch(service, { method: "GET" });
    return response.json();
  } catch (error) {
    return [];
  }
};

export const getSunburstPostData = async (
  endpoint,
  handleName,
  job_id,
  platform,
  path,
  startDate,
  endDate,
  mediaType,
  post_ids
) => {
  // ;
  const extraPayload = {
    date_from: moment(startDate).format(SYSTEM_DATETIME_FORMAT),
    date_to: moment(endDate).format(SYSTEM_DATETIME_FORMAT),
    handle_name: handleName,
    job_id: job_id,
    platform: platform,
    category_path: path,
    ...(mediaType && { media_type: mediaType }),
    post_ids: JSON.stringify(post_ids),
  };
  const payload = generatePayload(extraPayload);
  const service = createService(endpoint, payload);
  try {
    const response = await fetch(service, { method: "GET" });
    return response.json();
  } catch (error) {
    return [];
  }
};

export const getContentThemeData = async (
  handleName,
  job_id,
  platform,
  startDate,
  endDate
) => {
  const extraPayload = {
    date_to: moment(endDate).format(SYSTEM_DATETIME_FORMAT),
    date_from: moment(startDate).format(SYSTEM_DATETIME_FORMAT),
    handle_name: handleName,
    job_id: job_id,
    platform: platform,
  };
  const payload = generatePayload(extraPayload);
  const service = createService(GET_CONTENTTHEME_END_POINT, payload);
  try {
    const response = await fetch(service, { method: "GET" });
    return response.json();
  } catch (error) {
    return [];
  }
};
export function format_number_kform(num) {
  if ((num >= 1000) & (num < 1000000)) {
    return (Math.abs(num) / 1000).toFixed(1) + "K";
  } else if (num >= 1000000) {
    return (Math.abs(num) / 1000000).toFixed(1) + "M";
  } else {
    return num;
  }
}

export const getContentThemeDataOfRow = async (rowId) => {
  const extraPayload = {
    date_from: "1900-01-01",
    date_to: "2022-05-25",
    id: rowId,
  };
  const payload = generatePayload(extraPayload);
  const service = createService(GET_CONTENTTHEME_END_POINT, payload);
  try {
    const response = await fetch(service, { method: "GET" });

    return response.json();
  } catch (error) {
    return [];
  }
};

export const getBasicStatsData = async (
  handleName,
  job_id,
  platform,
  startDate,
  endDate
) => {
  const extraPayload = {
    date_to: moment(endDate).format(SYSTEM_DATETIME_FORMAT),
    date_from: moment(startDate).format(SYSTEM_DATETIME_FORMAT),
    handle_name: handleName,
    job_id: job_id,
    platform: platform,
  };
  const payload = generatePayload(extraPayload);
  const service = createService(GET_BASICSTATS_END_POINT, payload);
  try {
    const response = await fetch(service, { method: "GET" });

    return response.json();
  } catch (error) {
    return [];
  }
};

export const getDashboardPerformanceData = async (job_id) => {
  const payLoad = new URLSearchParams({
    username: username,
    system_uid: systemUid,
    job_id: job_id,
  });
  try {
    const response = await fetch(
      createService(GET_DASHBOARD_PERFORMANCE, payLoad.toString()),
      { method: "GET" }
    );
    return response.json();
  } catch (error) {
    return [];
  }
};

export const validatePostInput = (inp) => {
  var re_ = /.+\s+.+\s+.+/;
  let valid = false;
  if (re_.test(inp.trim()) && inp.trim().length >= 20) {
    return true;
  }
};
